import { IonContent, IonModal } from '@ionic/react';
import {
  useState,
  type ComponentProps,
  type Dispatch,
  type PropsWithChildren,
  type Ref,
  type SetStateAction,
} from 'react';

import styles from './ChooseMeasurementModal.module.css';

import { Button } from '../Button';
import { ModalFooter } from '../ModalFooter/ModalFooter';
import { ModalHeader } from '../ModalHeader/ModalHeader';
import { SessionTypeCard } from '../SessionTypeCard/SessionTypeCard';

interface ModalProps extends ComponentProps<typeof IonModal> {
  ref?: Ref<HTMLIonModalElement>;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

export const ChooseMeasurementModal = ({ setShowModal, ref, ...props }: PropsWithChildren<ModalProps>) => {
  const [selectedType, setSelectedType] = useState<string | null>(null);

  return (
    <>
      <IonModal className={styles.modal} {...props} onDidDismiss={() => setShowModal(false)} ref={ref}>
        <ModalHeader>Choose a Session Type</ModalHeader>

        <IonContent className={styles.content}>
          <div className={styles.inner}>
            <SessionTypeCard onSelect={setSelectedType} selected={selectedType === 'GO'} type={'GO'} />
            <SessionTypeCard onSelect={setSelectedType} selected={selectedType === 'ACL'} type={'ACL'} />
            <SessionTypeCard onSelect={setSelectedType} selected={selectedType === 'Hamstring'} type={'Hamstring'} />
          </div>
        </IonContent>

        <ModalFooter>
          {' '}
          <>
            <Button onClick={() => setShowModal(false)} variant='secondary'>
              Cancel
            </Button>

            <Button onClick={() => setShowModal(true)} variant='primary'>
              Start Session
            </Button>
          </>
        </ModalFooter>
      </IonModal>
    </>
  );
};
